<template>
  <div class="index">
    <!--头部 Header-->
    <div class="header">
      <!--图标-->
      <div class="logo">
        <img src="../assets/img/homeLogo.png" class="logo-img" />
        <span class="logo-title">{{ companyName }}</span>
      </div>
      <!--图标-->
      <!-- <div class="tips">
        <i class="el-icon-message-solid tips-icon"></i>
        <i class="el-icon-chat-line-round tips-icon"></i>
      </div> -->
      <div class="login">
        <!--右上角菜单-->
        <el-menu @open="handleOpen" @close="handleClose" background-color="#222222" text-color="#fff" active-text-color="#ffd04b">
          <el-submenu index="1">
            <template slot="title">
              <span style="color: white">{{ username }}（{{ roleName }}）</span>
              <i class="iconfont icon-zhankai"></i>
            </template>
            <!-- <el-menu-item @click="editPswdDialog = true"
                >修改密码</el-menu-item
              > -->
            <el-menu-item @click="logout">退出登录</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <!--身体 body-->
    <div class="container">
      <!--侧边菜单 Aside 原本是200-->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <el-tooltip class="item" effect="light" :content="isCollapse ? '展开' : '折叠'" placement="top-start">
          <div class="toggle-button" @click="toggleCollapse">|||</div>
        </el-tooltip>
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="active"
          :router="router"
          id="nav"
          style="font-size: 18px"
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
        >
          <el-submenu v-for="(item,index) in menus" :index="index.toString()" :key="item.id">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.menuName }}</span>
            </template>
            <el-menu-item v-for="itemS in item.childList" :index="itemS.routes" :key="itemS.id">
                <i :class="itemS.icon"></i>
                {{ itemS.menuName }}
              </el-menu-item>
          </el-submenu>
          <!-- <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-tickets"></i>
              <span slot="title">订单管理</span>
            </template>
            <el-menu-item index="/sku" v-if="username == 'admin' || username == 'GenDan' || username == 'user01'">
              <i class="el-icon-folder-opened"></i>
              SKU属性
            </el-menu-item>
            <el-menu-item index="/orderWrite">
              <i class="el-icon-notebook-2"></i>
              订单
            </el-menu-item>
            <el-menu-item index="/freightMaintain" v-if="username == 'admin' || username == 'GenDan'">
              <i class="el-icon-s-operation"></i>
              运费值维护
            </el-menu-item>
            <el-menu-item index="/restockPage" v-if="username == 'admin' || username == 'GenDan'">
              <i class="el-icon-s-claim"></i>
              补货建议
            </el-menu-item>
            <el-menu-item index="/adsGroups" v-if="username == 'admin' || username == 'GenDan'">
              <i class="el-icon-s-management"></i>
              广告管理
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3" v-if="username == 'admin'">
            <template slot="title">
              <i class="el-icon-files"></i>
              <span slot="title">财务报表</span>
            </template>
            <el-menu-item index="/exchangeRate">
              <i class="el-icon-s-cooperation"></i>
              汇率管理
            </el-menu-item>
            <el-menu-item index="/grossProfit">
              <i class="el-icon-s-promotion"></i>
              毛利润
            </el-menu-item>
            <el-menu-item index="/reimbursement">
              <i class="el-icon-printer"></i>
              报销管理
            </el-menu-item>
            <el-menu-item index="/cost">
              <i class="el-icon-s-shop"></i>
              成本管理
            </el-menu-item>
            <el-menu-item index="/monthlyProfit">
              <i class="el-icon-coin"></i>
              月利润查看
            </el-menu-item>
          </el-submenu> -->
        </el-menu>
      </el-aside>
      <!--内容 Main-->
      <el-main>
        <keep-alive include="resourceSearch">
          <router-view />
        </keep-alive>
      </el-main>
    </div>
    <!-- 修改密码弹框 -->
    <el-dialog title="修改用户密码" width="600px" :visible.sync="editPswdDialog" class="import-dialog" left>
      <el-form label-width="110px" :model="editPswd" ref="editPswd" :rules="rules">
        <el-form-item label="原密码:" prop="oldPass">
          <el-input type="password" v-model="editPswd.oldPass" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="newPass">
          <el-input type="password" v-model="editPswd.newPass" placeholder="请设置新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="newPass2">
          <el-input type="password" v-model="editPswd.newPass2" placeholder="请确认新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPswdDialog = false">取 消</el-button>
        <el-button @click="editPswdBtn" type="primary">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<!--行为-->
<script>
import axios from "axios";

export default {
  /*属性定义*/
  data() {
    //此处即表单发送之前验证
    let validateNewPassword = (rule, value, callback) => {
      if (value === this.editPswd.oldPass) {
        callback(new Error("新密码不能与原密码相同!"));
      } else {
        callback();
      }
    };
    let validateNewPassword2 = (rule, value, callback) => {
      if (value !== this.editPswd.newPass) {
        callback(new Error("与新密码不一致!"));
      } else {
        callback();
      }
    };

    let user = JSON.parse(sessionStorage.getItem("user"));
    if (user == null) {
        this.$router.push("/login");
    }
    //console.log('username', user.userName);
    return {
      categoryIndex: 0,
      isChildActive: 0,
      isActive: 0,
      active: "/resouceSearch" /*当前选中菜单*/,
      props: {
        index: {
          required: true,
        },
      },
      router: true,
      username: user.userName,
      roleName: user.roleName,
      companyName: user.companyName,
      userLogo: require("../assets/img/user.jpg"),
      menus: [{}] /*菜单*/,
      editPswdDialog: false /*修改密码*/,
      editPswd: {
        oldPass: "",
        newPass: "",
        newPass2: "",
      },
      rules: {
        oldPass: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPass: [
          { required: true, message: "请设置新密码", trigger: "blur" },
          { validator: validateNewPassword, trigger: "blur" },
        ],
        newPass2: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: validateNewPassword2, trigger: "blur" },
        ],
      },
      isCollapse: false,
    };
  },
  /*created方法*/
  created() {
    this.getUserAuthTree();//获取所有用户菜单
  },
  /*created后调用mounted*/
  mounted: function() {
    this.active = this.$route.name; /*刷新后选中菜单*/
    this.clkChangeColor(window.sessionStorage.getItem("isActive"));
    this.clkChangeChildColor(window.sessionStorage.getItem("isChildActive"));
  },
  methods: {
    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    /*退出登录方法*/
    logout() {
      this.$msgbox
        .confirm("此操作将退出该系统, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          // window.sessionStorage.clear(); /*清除所有sessionStorage缓存*/
          // this.$router.push("/login");
          // this.$message("退出成功！");
          this.axios.get("/api/user-info/logout").then(
            resp => {
              sessionStorage.clear(); /*清除所有sessionStorage缓存*/
              this.$router.push('/login');
              this.$message("退出成功！");
            },
            err => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消退出");
        });
    },
    /*更改菜单颜色*/
    clkChangeColor(index) {
      window.sessionStorage.setItem("isActive", index);
      this.isActive = index;
    },
    clkChangeChildColor(index) {
      window.sessionStorage.setItem("isChildActive", index);
      this.isChildActive = index;
    },
    /*菜单打开方法*/
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    /*菜单关闭方法*/
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    /*获取所有权限方法*/
    getUserAuthTree() {
      /*获取用户权限*/
      this.axios.get("/api/user-info/getRoleAndMenu").then((r) => {
        let data = r.data.data;
        //赋值给定义的data属性
        this.menus = data;
        //data为集合 判断所有的按钮权限
        let authority = [];
        // data.forEach(function(item, index) {
        //   item.childList.forEach(function(item1, index1) {
        //     item1.childList.forEach(function(item2, index2) {
        //       if (item2.type == 3) {
        //         authority.push(item2.permission);
        //         if (item2.childList != null) {
        //           item2.childList.forEach(function(item3, index3) {
        //             if (item3.type == 3) {
        //               authority.push(item3.permission);
        //             }
        //           });
        //         }
        //       }
        //     });
        //   });
        // });
        window.sessionStorage.setItem("authority", authority);
      });
    },
    /*修改密码方法*/
    editPswdBtn() {
      this.$refs["editPswd"].validate((valid) => {
        if (valid) {
          let u = { ...this.editPswd };
          this.axios.post("/sitemap/user/updatePassword?oldPass=" + u.oldPass + "&newPass=" + u.newPass).then(
            (resp) => {
              this.editPswdDialog = false;
              let msg = resp.data.msg;
              this.$message(msg);
            },
            (err) => {
              console.log("err", err);
            }
          );
        } else {
          this.$message.error("请正确填写表单");
          return false;
        }
      });
    },
    queryGroupId(index) {
      /*获取分组id，自定义全局属性去接收*/
      this.categoryIndex = index;
    },
  },
};
</script>
<!--表现 css-->
<style lang="less" scoped>
.index {
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  .header {
    height: 56px;
    background: linear-gradient(90deg, #2a3861, #222222);
    display: flex;
    justify-content: space-between;
    position: relative;
    .logo {
      width: 400px;
      color: #fff;
      text-align: left;
      line-height: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-left: 15px;

      &-img {
        width: 30px;
        height: 36px;
      }
      &-title {
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        letter-spacing: 3px;
        font-size: 22px;
        text-align: left;
      }
    }
    .tips {
      width: 100px;
      height: 56px;
      position: absolute;
      top: 0%;
      right: 200px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      &-icon {
        font-size: 26px;
        color: #fff;
      }
    }
    .login {
      width: 180px;
      height: 56px;
      z-index: 11;
      .el-menu {
        width: 120px;
        border: #ffd04b;
        font-size: 16px;
        .el-submenu {
          text-align: center;
          .el-menu-item {
            width: 100%;
            padding: 0 !important;
            text-align: center;
          }
        }
      }
    }
  }

  .container {
    height: calc(100% - 56px);
    display: flex;
    justify-content: space-between;

    .el-aside {
      width: 200px;
      overflow-y: auto;
      background: linear-gradient(150deg, #222222 0%, #1f2233 100%);
      .el-menu {
        text-align: left;
        background-color: transparent; /*透明色*/
        border-right: none;
        i {
          /*默认图标颜色*/
          color: white;
        }
        .el-submenu__title:hover{
          background-color: #282811 !important;
          color: white !important;
        }
        .el-submenu span {
          /*默认文字颜色*/
          color: white;
          font-size: 16px;
        }
        .el-menu-item {
          /*默认菜单*/
          background-color: #282811;
          color: white !important;
          i {
            color: white; /*选中图标颜色*/
          }
          &:hover {
            /*光标移入事件*/
            color: #565b85 !important;
            background-color: rgba(227, 227, 227, 0.22) !important;
          }
        }
        .el-menu-item.active {
          background-color: #e3eafc !important;
          color: #656d92 !important;
          span, a {
            color: #656d92 !important;
          }
        }
        .el-menu-item.is-active {
          /*选中颜色变化*/
          background-color: #e3eafc;
          color: #656d92 !important;

          i {
            color: #656d92; /*选中图标颜色*/
          }
        }
      }
    }
    .el-main {
      flex: 1;
      width: 100%;
      height: 100vh;
      background: #f0f2f5 url("../assets/img/dt.png") no-repeat center;
      background-size: 100%;
      background-size: cover;
      background-position: center;
      -webkit-font-smoothing: antialiased;
      font-size: 12px;
      padding: 6px 12px;
      overflow: hidden;
    }
  }

  .toggle-button {
    // 添加背景颜色
    background-color: #4a5064;
    // 设置文本大小
    font-size: 16px;
    // 设置文本行高
    line-height: 30px;
    // 设置文本颜色
    color: #fff;
    // 设置文本居中
    text-align: center;
    // 设置文本间距
    letter-spacing: 0.2em;
    // 设置鼠标悬浮变小手效果
    cursor: pointer;
  }

  .active {
    color: #454b64 !important;
  }

  /deep/.menuSub {
    margin: 10px;
  }
  /deep/.el-submenu .el-menu-item {
    height: 50px;
    line-height: 50px;
    padding: 0 45px;
    min-width: 110px;
  }
  /deep/.el-menu-item-group__title {
    padding: 0px;
    line-height: normal;
    font-size: 12px;
    color: #909399;
  }

  /deep/a:link {
    text-decoration: none;
  }
}
</style>
